import { ComponentType } from 'react';
import { NavigateOptions } from 'react-router';
import { URLSearchParamsInit, useLocation, useParams, useSearchParams } from 'react-router-dom';
import { usePoolNavigate } from '@synergy/components-next';

/** @deprecated Use `React Router hooks` instead */
export interface WithRouterProps {
    location: ReturnType<typeof useLocation>;
    params: Record<string, string>;
    searchParams: URLSearchParams;
    setSearchParams: (
        nextInit?: URLSearchParamsInit | ((prev: URLSearchParams) => URLSearchParamsInit),
        navigateOpts?: NavigateOptions
    ) => void;
    navigate: ReturnType<typeof usePoolNavigate>;
}

/** @deprecated Use `React Router hooks` instead */
export const withRouter = <T extends WithRouterProps>(Component: ComponentType<T>) => {
    return (props: Omit<T, keyof WithRouterProps>) => {
        const location = useLocation();
        const params = useParams();
        const [searchParams, setSearchParams] = useSearchParams();
        const navigate = usePoolNavigate();

        return (
            <Component
                {...(props as T)}
                location={location}
                params={params}
                navigate={navigate}
                searchParams={searchParams}
                setSearchParams={setSearchParams}
            />
        );
    };
};

// Source: https://blog.whereisthemouse.com/how-to-use-withrouter-hoc-in-react-router-v6-with-typescript
